import { useEffect, useState, memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, CircularProgress } from '@material-ui/core';
import { systemAPI } from '../../apis';
import downloadFileByBase64 from '../../utils/downloadFileByBase64';
import { DocIcon } from '../Icon';
import { onKeyUpEnterOrSpace } from '../../utils';

const useStyles = makeStyles((theme) => ({
  file: {
    height: '3.125rem',
    minWidth: '16.563rem',
    margin: '0.938rem 0.938rem 0 0',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    paddingRight: '1rem',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  box: {
    width: '1.875rem',
    height: '1.875rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 0.625rem',
  },
  docIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: theme.palette.primary.main,
  },
}));

const File = ({ id, url, name, type }) => {
  const classes = useStyles();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isFail, setIsFail] = useState(false);

  const getFileAPI = async (props) => {
    try {
      const { result } = await systemAPI.getSysNotificationFile({ fileIds: props }, { isHideLoading: true });
      setData(result[0]);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setIsFail(true);
      console.log('---getFileAPI---', error);
    }
  };

  useEffect(() => {
    if (type === 'notification') {
      (async () => {
        await getFileAPI([id]);
      })();
    }
  }, []);

  const returnNotificationFile = () => {
    if (isLoading) {
      return (
        <Box width="16.563rem" height="3.125rem" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="primary" />
        </Box>
      );
    } else {
      return isFail ? null : (
        <div
          className={classes.file}
          onClick={() => downloadFileByBase64(`data:${data?.mineType};base64,${data?.fileDesc}`, data?.fileName)}
          tabIndex={0}
          onKeyUp={(e) =>
            onKeyUpEnterOrSpace(e, () =>
              downloadFileByBase64(`data:${data?.mineType};base64,${data?.fileDesc}`, data?.fileName)
            )
          }
        >
          <div className={classes.box}>
            <DocIcon className={classes.docIcon} />
          </div>
          {data?.fileName}
        </div>
      );
    }
  };

  return type === 'notification' ? (
    returnNotificationFile()
  ) : (
    <div
      className={classes.file}
      onClick={() => window.open(url)}
      tabIndex={0}
      onKeyUp={(e) => onKeyUpEnterOrSpace(e, () => window.open(url))}
    >
      <div className={classes.box}>
        <DocIcon className={classes.docIcon} />
      </div>
      {name}
    </div>
  );
};

export default memo(File);
